/**
 * Created by Administrador on 01/03/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('saleChannelService', saleChannelService)

    saleChannelService.$inject = ['$http', 'CONFIG', 'messageService'];

    function saleChannelService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/salesChannel',
            service = {
                getRegionsSaleChannel: getRegionsSaleChannel,
                getSaleChannelGroupsByRegion: getSaleChannelGroupsByRegion
            };

        return service;

        function getRegionsSaleChannel(){
            return $http.get(urlBase + "/regions")
                .then(function(response){
                    return (response.data)? response.data : [];
                })
                .catch(function(){
                    messageService.findAllError('rules');
                });
        }

        function getSaleChannelGroupsByRegion(region){
            return $http.get(urlBase + "/byRegion/" + region)
                .then(function(response){
                    return (response.data._embedded)? response.data._embedded.saleChannels : [];
                })
                .catch(function(){
                    messageService.findAllError('rules');
                });
        }
    }
})();
